import { useRequest } from "~/api/Request"
import API_V2 from "~/api/api-v2"
import { FileObject, UploadDocument, UploadedBucketFile } from "~/model/Workflow"
import * as Sentry from "@sentry/browser"
import { ErrorCode } from "~/constants/errors"
import dayjs from "dayjs"
import { MajorItem } from "~/model/FormBLC"
import { FormData as FormDataModel } from "~/model/Form"

export function useBlc() {
  const { Request } = useRequest()
  return {
    registerPdf: async (data: UploadDocument) => {
      try {
        const url = API_V2.BLC_REGISTER
        const formData = new FormData()
        formData.append("document", data.fileBlob, encodeURI(data.file.name))

        const response = await Request.post<FileObject>(url, formData, {
          headers: {
            "content-type": "multipart/form-data",
          },
        })
        return response.data
      } catch (error) {
        console.log("[LOG] BLC Service Error", error)
        Sentry.captureException(error)
        throw new Error(ErrorCode.REGISTER_ERROR)
      }
    },

    downloadPdf: async (pdfId: string, callback?: ({ percent: number }) => void) => {
      try {
        const url = `${API_V2.BLC_DOWNLOAD}?pdfId=${pdfId}`
        const response = await Request.downloadFile<Buffer>(
          url,
          {},
          {
            responseType: "arraybuffer",
          },
          (percent) => {
            callback?.call(this, { percent: percent })
            if (percent === 100) {
              console.info("progress", percent)
            }
          }
        )
        return response.data
      } catch (error) {
        console.log("[LOG] BLC Service Error", error)
        Sentry.captureException(error)
        throw new Error(ErrorCode.REGISTER_ERROR)
      }
    },
    generateSignData: (
      pdfId: string,
      items: { [index: string]: string },
      forms?: FormDataModel[],
      infoItems?: { [index: string]: string }
    ) => {
      console.info("契約サイン")
      console.info(pdfId, items)
      forms = forms || []
      const signedData =
        infoItems.date || items["日付"]
          ? items
          : { 日付: dayjs().format("YYYY/MM/DD HH:mm (UTC Z)"), ...infoItems }
      const detailItems: MajorItem[] = [
        {
          title: "電子契約情報",
          body: [
            {
              subTitle: "契約情報",
              pairs: Object.keys(signedData).map((key) => {
                return { key, value: signedData[key] ? `${signedData[key]}` : "" }
              }),
            },
          ],
        },
      ]

      const formItems: any = {
        title: "電子契約内容",
        body: forms.map((f) => {
          const pairs = []
          for (let i = 0; i < f.data.length; i++) {
            if (f.data[i]?.title === "第" && f.data[i - 1]?.title === "登録番号（免許番号）")
              continue
            if (f.data[i].title === "登録番号（免許番号）" && f.data[i + 1]?.title === "第") {
              pairs.push({
                key: f.data[i].title,
                value: `${f.data[i].value}  知事  第  ${f.data[i + 1]?.value}号`,
              })
            } else {
              pairs.push({
                key: f.data[i].title,
                value: f.data[i]?.value ? `${f.data[i]?.value}` : "",
              })
            }
          }
          return {
            subTitle: f.name,
            pairs,
          }
        }),
      }
      if (Object.keys(items).length) {
        const pairs = []
        for (const key in items) {
          pairs.push({ key, value: items[key] || "" })
        }
        formItems.body.push({
          subTitle: "",
          pairs,
        })
      }
      detailItems.push(formItems)
      console.log("[LOG] : detailItems:", detailItems)
      return {
        signTime: signedData["日付"],
        signItems: detailItems,
      }
    },
  }
}
